export const setAuth = (token, user) => {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
};

export const getAuth = () => {
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');
  const user = userStr ? JSON.parse(userStr) : null;
  return { token, user };
};

export const clearAuth = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('supportTenantContext');
  window.dispatchEvent(new Event('support-context-changed'));
};

export const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

export const getSupportContext = () => {
  const stored = localStorage.getItem('supportTenantContext');
  return stored ? JSON.parse(stored) : null;
};

export const setSupportContext = (context) => {
  if (!context) {
    localStorage.removeItem('supportTenantContext');
    window.dispatchEvent(new Event('support-context-changed'));
    return;
  }
  localStorage.setItem('supportTenantContext', JSON.stringify(context));
  window.dispatchEvent(new Event('support-context-changed'));
};

export const clearSupportContext = () => {
  localStorage.removeItem('supportTenantContext');
  window.dispatchEvent(new Event('support-context-changed'));
};

export const isSupportUser = (user) => ['super_admin', 'admin', 'internal_support'].includes(user?.role);